import {Song} from '../../components/song/song.types';

export enum slideUpTitles {
	addReorderSetlist = 'Add & Reorder Setlist',
	almostDone = 'Almost Done!',
	songPlayed = 'Song Played?',
}

export const getFirstUndefinedPlayState = (setlist: Song[]) => {
	const sortedSetlist = sortSetlistByIndex(setlist);
	sortedSetlist.sort((a, b) => a.index - b.index);
	const index = sortedSetlist.find((item) => item.played === undefined)?.index;
	return index;
};

export const sortSetlistByIndex = (setlist: Song[]): Song[] => {
	const clone = [...setlist];
	return clone.sort((a, b) => a.index - b.index);
};

export const getCurrentSong = (setlist: Song[]): Song => {
	const index = getFirstUndefinedPlayState(setlist);
	if (index !== undefined) {
		const song = setlist.find((item) => item.index === index) as Song;
		return song;
	}
	const sortedSetlist = sortSetlistByIndex(setlist);
	return sortedSetlist.at(-1) as Song;
};
